export default "__VITE_ASSET__0b0cde0a__"